var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.25001C16.6667 3.94882 14.8012 2.08334 12.5 2.08334C10.1988 2.08334 8.33333 3.94882 8.33333 6.25001V12.5C8.33333 14.8012 10.1988 16.6667 12.5 16.6667C14.8012 16.6667 16.6667 14.8012 16.6667 12.5V6.25001Z",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20833 10.9375V12.5C5.20833 16.5271 8.47291 19.7917 12.5 19.7917C16.5271 19.7917 19.7917 16.5271 19.7917 12.5V10.9375",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.60416V5.72916",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 8.33334H10.9375",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 8.33334H16.6667",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 11.4583H10.9375",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 11.4583H16.6667",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.7917V22.9167",
    stroke: "currentColor",
    strokeWidth: 1.875
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 22.9167H16.6667",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrophone);
export default __webpack_public_path__ + "static/media/icon-microphone.5c6e014cb1d3da3f48125ab5bc8dba1f.svg";
export { ForwardRef as ReactComponent };